
import { set } from '@/utils/vuex'
import { getConfig } from '@/api/user'


const state = {
  loading: false,
  drawer: null,
  config: {},
  protocol: JSON.parse(localStorage.getItem('protocol') || null) || { id: -1 },
  // color: 'success',
  // image: '',
  // sidebarBackgroundColor: 'rgba(27, 27, 27, 0.84)',
  // snackbar: {}

  // accountDialog: false,
  // disposalDialog: false,

  // accountItem: {},
  // disposalItem: {}

}

const mutations = {
  loading: set('loading'),
  setDrawer: set('drawer'),

  setProtocol: set('protocol', true),
  
  SET_CONFIG: (state, v) => {
    state.config = v
  },

  // setImage: set('image'),
  // setColor: set('color'),
  // // snackbar: set('snackbar'),

  // accountDialog: set('accountDialog'),
  // accountItem: set('accountItem'),
  // disposalDialog: set('disposalDialog'),
  // disposalItem: set('disposalItem')
}

const actions = {
  startLoading: (context) => {
    context.commit('loading', true)
  },
  stopLoading: (context) => {
    context.commit('loading', false)
  },
  async getConfig({ commit }) {
    const ret = await getConfig()
    commit('SET_CONFIG', ret)
  }
  // openAccountDialog: (context, payload = {}) => {
  //   context.commit('accountItem', payload) // THIS ORDER IS IMPORTANT!!!
  //   context.commit('accountDialog', true) // THIS ORDER IS IMPORTANT!!!
  // },
  // closeAccountDialog: context => {
  //   context.commit('accountDialog', false)
  //   // context.commit('variableItem', {})
  // },
  // openDisposalDialog: (context, payload = {}) => {
  //   context.commit('disposalItem', payload)
  //   context.commit('disposalDialog', true) // THIS ORDER IS IMPORTANT!!!
  // },
  // closeDisposalDialog: context => {
  //   context.commit('disposalDialog', false)
  // },
  // openSnackbar: (context, payload) => {
  //   payload['active'] = true
  //   context.commit('snackbar', payload)
  // },
  // closeSnackbar: context => {
  //   context.commit('snackbar', { active: false })
  // }
  // setSchema (context, payload) {
  //   context.commit('setSchema', payload)
  // }
}

// const getters = {
//   variableDialog: state => {
//     return state.variable_dialog
//   },
//   variableItem: state => {
//     return state.variable_item
//   }
// }

export default {
  // getters
  namespaced: true,
  state,
  mutations,
  actions
}
